module.exports = __webpack_public_path__ + "static/media/foto2.cef92538.png";